/* eslint-disable array-callback-return */
import React, { useState, useRef, useContext } from "react"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Calendar } from "primereact/calendar"
import { Fieldset } from "primereact/fieldset"
import { Toolbar } from "primereact/toolbar"
import { Toast } from "primereact/toast"
import CustomToolBar from "../../../ToolBar/customToolbar"
import { clientTypes } from "../../../types/dropDownTypes"
import { errorMessages } from "../../../types/messages"
import PropTypes from "prop-types"
import {
  existsErrors,
  filterAdditionalQuestions,
  formatMixedQuestions,
  getAdditionalQuestions,
  showMessage,
  showQuestion,
  updateState,
  validateQuestions,
  checkDisplayConditional,
  checkConditionalRender,
} from "../../../utils/utils"
import { GpraContext } from "../../../../../context/gpraContext"
import { endpoints } from "../../../../../config/gpraApiEndpoints"
import "../../../../../styles/Participant-GPRA.module.css"
import FormLabel from "../../../Common/FormLabel"
import FormError from "../../../Common/FormError"
import { UserContext } from "../../../../../context/userContext"
import { useQuery } from "@apollo/client/react"
import { GET_USER } from "../../../../User/queries"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { INTERVIEW_SECTIONS } from "../../../types/interviewTypes"
import { useEffect } from "react"
import AdditionalQuestionContainer from "../../Additional/AdditionalQuestionContainer"

const RecordMgmt = (props) => {
  const { showToolBar, disabled } = props
  const {
    handleSubmitPut,
    interviewType,
    sectionsCompleted,
    handleSectionsCompleted,
    questions,
    additionalQuestions,
    interview,
    updateInterviewValues,
    activeIndex,
    sections,
    editMode,
  } = useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [validationErrors, setValidationErrors] = useState({})
  const [staffUser, setStaffUser] = useState()
  const [recordManagement, setRecordManagement] = useState(
    interview[INTERVIEW_SECTIONS.RECORD_MGMT]
  )
  const [mixedQuestions, setMixedQuestions] = useState([])
  const toast = useRef()

  useEffect(() => {
    if (mixedQuestions.length === 0) {
      let filteredQuestions = []
      let filteredAdditional = []
      if (questions) {
        filteredQuestions = questions?.filter(
          (q) => q.section === INTERVIEW_SECTIONS.RECORD_MGMT
        )
      }
      if (additionalQuestions) {
        filteredAdditional = filterAdditionalQuestions(
          additionalQuestions,
          INTERVIEW_SECTIONS.RECORD_MGMT
        )
      }

      setMixedQuestions(
        formatMixedQuestions(filteredQuestions, filteredAdditional)
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, additionalQuestions])

  useQuery(GET_USER, {
    variables: { staff_id: userCtx.session.user.staff_id },
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setStaffUser(data)
    },
  })

  const saveData = (setNextForm, prevForm, setNavigationItem) => {
    updateInterviewValues(INTERVIEW_SECTIONS.RECORD_MGMT, recordManagement)
    if (!prevForm) {
      if (validationForm()) {
        handleSubmitPut(endpoints.START_INTERVIEW, {
          gpra_organization_uuid: userCtx.session.user.organization_id,
          gpra_participation_consent: true,
          gpra_interview_type: interviewType,
          gpra_client_type:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].gpra_client_type,
          gpra_staff_uuid: userCtx.session.user.staff_id,
          gpra_staff_id: interview[INTERVIEW_SECTIONS.RECORD_MGMT].staff_alias,
          date_start:
            interview[INTERVIEW_SECTIONS.RECORD_MGMT].gpra_interview_date,
          gpra_participant_uuid: userCtx.participant_id,
          gpra_membership_uuid: userCtx.participant_membership_id,
          gpra_staff_email: staffUser?.user?.staff_email_address,
          additional: getAdditionalQuestions(recordManagement),
          administrative_interview: false,
          editMode: editMode,
        }).then((response) => {
          if (response.status === 200 || response.status === 201) {
            updateInterviewValues(INTERVIEW_SECTIONS.RECORD_MGMT, {
              ...recordManagement,
              staff_id: response?.data?.gpraStaffUuid,
            })
            setNextForm(sections[activeIndex + 1]?.section)
            setNavigationItem()
            handleSectionsCompleted({
              ...sectionsCompleted,
              ...{ recordMgmt: true },
            })
          }
        })
      } else {
        showMessage(false, errorMessages.toastErrorDetail, toast)
      }
    }
  }

  const validationForm = () => {
    const errors = {}
    if (
      !recordManagement?.gpra_client_type &&
      showQuestion(questions, "gpra_client_type")
    ) {
      errors["gpra_client_type"] = errorMessages.requiredMessage
    }
    if (
      !recordManagement.gpra_interview_date &&
      showQuestion(questions, "gpra_client_type")
    ) {
      errors["gpra_interview_date"] = errorMessages.requiredMessage
    }

    setValidationErrors(
      validateQuestions(
        recordManagement,
        INTERVIEW_SECTIONS.RECORD_MGMT,
        additionalQuestions,
        errors,
        questions
      )
    )
    return existsErrors(errors)
  }

  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }

  const renderDefaultMain = (question) => {
    return (
      <>
        {question.field === "gpra_interview_date" && (
          <div className={gpraStyles.formRow}>
            <FormLabel label={`${question.number}. Interview Date`} required />
            <Calendar
              disabled={disabled}
              className={
                validationErrors.interviewDate
                  ? gpraStyles.calendarError
                  : gpraStyles.calendar
              }
              showIcon
              showButtonBar
              monthNavigator
              yearNavigator
              yearRange={`1900:${new Date().getFullYear()}`}
              value={recordManagement.gpra_interview_date}
              onChange={(e) => {
                updateState(
                  "gpra_interview_date",
                  e.value,
                  null,
                  null,
                  recordManagement,
                  setRecordManagement
                )
                removeError("gpra_interview_date")
              }}
              maxDate={new Date()}
            />
            <FormError error={validationErrors.interviewDate} />
          </div>
        )}
        {question.field === "gpra_participant_id" && (
          <div className={gpraStyles.formRow}>
            <FormLabel label={`${question.number}. Client ID`} />
            <InputText
              className={
                validationErrors.participantId
                  ? gpraStyles.invalid
                  : gpraStyles.ml1
              }
              id="clientId"
              type="text"
              value={recordManagement.gpra_participant_id}
              onChange={(e) => {
                updateState(
                  "gpra_participant_id",
                  e.value,
                  null,
                  null,
                  recordManagement,
                  setRecordManagement
                )
                removeError("gpra_participant_id")
              }}
              disabled
            />
          </div>
        )}
        {question.field === "gpra_client_type" && (
          <div className={gpraStyles.formRow}>
            <FormLabel
              label={`${question.number}. Client Description by Grant Type`}
              required
            />
            <Dropdown
              className={
                validationErrors["gpra_client_type"]
                  ? gpraStyles.input5Error
                  : gpraStyles.input5
              }
              value={recordManagement.gpra_client_type}
              onChange={(e) => {
                updateState(
                  "gpra_client_type",
                  e.value,
                  null,
                  null,
                  recordManagement,
                  setRecordManagement
                )
                removeError("gpra_client_type")
              }}
              options={clientTypes}
              optionLabel="label"
              optionValue="value"
              showClear={recordManagement.gpra_client_type}
              disabled={disabled}
            />
            <FormError error={validationErrors["gpra_client_type"]} />
          </div>
        )}
      </>
    )
  }

  return (
    <>
      <Toast ref={toast} />
      {showToolBar && (
        <Toolbar
          className={gpraStyles.mb2}
          right={
            <CustomToolBar
              nextForm={true}
              prevForm={false}
              saveData={saveData}
              toast={toast}
              showCancel={false}
            />
          }
        ></Toolbar>
      )}
      <Fieldset legend="A. RECORD MANAGMENT" style={{ marginBottom: "1rem" }}>
        <div className={gpraStyles.grid}>
          {mixedQuestions?.map((question) => {
            if (question.kind === "default") {
              if (question.show) {
                return renderDefaultMain(question)
              }
            } else {
              if (
                checkConditionalRender(
                  question.enabled,
                  question.required,
                  question.kind,
                  question.conditionalSource
                )
              ) {
                return (
                  <AdditionalQuestionContainer
                    entity={recordManagement}
                    setEntity={setRecordManagement}
                    errors={validationErrors}
                    section={INTERVIEW_SECTIONS.RECORD_MGMT}
                    removeError={removeError}
                    disabled={disabled}
                    question={question.question}
                    number={question.number}
                    kind={question.kind}
                  />
                )
              } else {
                if (checkDisplayConditional(question, recordManagement)) {
                  return (
                    <AdditionalQuestionContainer
                      entity={recordManagement}
                      setEntity={setRecordManagement}
                      errors={validationErrors}
                      section={INTERVIEW_SECTIONS.RECORD_MGMT}
                      removeError={removeError}
                      disabled={disabled}
                      question={question.question}
                      number={question.number}
                      kind={question.kind}
                    />
                  )
                }
              }
            }
          })}
        </div>
      </Fieldset>
    </>
  )
}
RecordMgmt.propTypes = {
  showToolBar: PropTypes.bool,
  disabled: PropTypes.bool,
}
RecordMgmt.defaultProps = {
  showToolBar: true,
  disabled: false,
}
export default RecordMgmt
